

























































































































import Layout from './Layout'
import RtsPacMan from '@rhitics/vue/components/RtsPacMan/index.vue'
import AccessMenu from './AccessMenu/index.vue'
import RtsStagingMark from '@rhitics/vue/components/RtsStagingMark.vue'
import { toRhitics } from '@rhitics/utils/links'

export default Layout.extend({
  name: 'AppLayout',

  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    showAside: {
      type: Boolean,
      default: true
    },
    showAsideContent: {
      type: Boolean,
      default: true
    }
  },

  components: {
    AccessMenu,
    RtsPacMan,
    RtsStagingMark
  },

  data() {
    return {
      mini: false,
      drawer: false,
      isShowUserMenu: false,
      isNavDrawerEmpty: false,
      isDrawerPinned: false
    }
  },

  computed: {
    appName(): string {
      return this.$store.state.appName
    },
    isDevMode(): boolean {
      return process.env.NODE_ENV === 'development'
    },
    isStaging(): boolean {
      return process.env.VUE_APP_ENV === 'staging'
    },
    isMediumSizeOrDown(): boolean {
      return this.$vuetify.breakpoint.width <= 960
    },
    computedDrawerWidth(): string {
      if (this.isDrawerPinned || this.showAsideContent) {
        return '326px'
      }
      return '56px'
    }
  },

  created() {
    this.drawer = !this.isMediumSizeOrDown

    const savedPinState = localStorage.getItem('drawer_pinned')
    if (savedPinState !== null) {
      this.isDrawerPinned = savedPinState === 'true'
    }
  },

  mounted() {
    // 當使用者調整尺寸經過斷點時，關閉 mini，避免使用者打不開
    this.$watch('isMediumSizeOrDown', () => (this.mini = false))
  },

  methods: {
    toggle() {
      this.drawer = !this.drawer
    },

    to(page) {
      toRhitics(page)
    },

    toggleDrawerPin() {
      this.isDrawerPinned = !this.isDrawerPinned

      localStorage.setItem('drawer_pinned', String(this.isDrawerPinned))

      // trigger mini-variant to reset drawer when un-pin
      if (!this.isDrawerPinned) {
        this.mini = true
        this.$nextTick(() => {
          this.mini = false
        })
      }
    }
  }
})
